import * as Reselect from "reselect";

import {SPORT_PAGE} from "@atg-sport-shared/sportsbook-utils-constants";
import {
    kambiHashMatcher,
    kambiPathMatcher,
} from "@atg-sport-shared/sportsbook-utils-helpers";

import type {
    GlobalSportState,
    GlobalState,
    SportsbookRoute,
} from "@atg-sport-shared/sportsbook-types-root";

// Route Kambi has reported it's on...
const routeSelector = (
    state: GlobalSportState,
): SportsbookRoute | Record<string, never> =>
    state.sportsbook?.route ? state.sportsbook.route : {};

export const getRaw = Reselect.createSelector(routeSelector, (route) => route?.raw || "");

export const getPage = Reselect.createSelector(
    routeSelector,
    (route) => route?.page || "",
);

export const getSport = Reselect.createSelector(
    routeSelector,
    (route) => route?.sport || "",
);

export const getLeague = Reselect.createSelector(
    routeSelector,
    (route) => route?.league || "",
);

export const getEventId = Reselect.createSelector(
    routeSelector,
    (route) => route?.eventId,
);

export const getAttribute = Reselect.createSelector(
    routeSelector,
    (route) => route?.attribute || "",
);

export const isMissingRoute = Reselect.createSelector(
    routeSelector,
    (route) => route?.isMissingRoute,
);

// Route we know the browser is on...
const getLocation = (state: GlobalState) =>
    state.router?.location || {hash: undefined, search: undefined, pathname: undefined};

const getHash = Reselect.createSelector(
    getLocation,
    // App uses raw as fallback
    getRaw,
    ({hash}, raw) => hash?.replace(/^#/g, "") ?? raw.split("?")[0],
);
const getPathname = Reselect.createSelector(getLocation, ({pathname}) => pathname);
const getSearch = Reselect.createSelector(
    getLocation,
    getRaw,
    ({search}, raw) => search ?? raw.split("?")[1],
);

type SportRouteResult = {
    attribute: string;
    eventId?: string;
    hash: string;
    pathname: string;
    search?: string;
    sport: string;
    league: string;
    page?: string;
    raw: string;
    region?: string;
    participant?: string;
    isLiveEvent?: string;
    filterType?: string;
};

export const getSportRoute = Reselect.createSelector(
    getHash,
    getPathname,
    getSearch,
    getEventId,
    getSport,
    getLeague,
    getAttribute,
    (
        hash = "",
        pathname = "",
        search,
        eventId,
        sport,
        league,
        attribute,
    ): SportRouteResult => {
        const pathnameMatch = kambiPathMatcher(pathname);
        const kambiMatch = kambiHashMatcher(hash);

        const page =
            (pathnameMatch.page === SPORT_PAGE.TIPS && pathnameMatch.page) ||
            kambiMatch.page ||
            pathnameMatch.page;

        return {
            attribute,
            eventId,
            hash,
            pathname,
            search,
            sport,
            league,
            ...pathnameMatch,
            ...kambiMatch,
            page,
            raw: hash,
        };
    },
);
